import SafeIcon from './SafeIcon';
import { useApp } from '../i18n/AppContext';

export default function NotYetSheet({ title, onClose }: { title: string; onClose: () => void }) {
  const { translate } = useApp();
  return (
    <div
      className="drawer-backdrop notyet-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        className="drawer notyet-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="notyet-title"
      >
        <div className="drawer-header">
          <div>
            <span className="tag">
              <SafeIcon name="FiTool" size={12} /> {translate('Next prototype round')}
            </span>
            <h2 id="notyet-title" style={{ marginTop: 10 }}>
              {translate(title)}
            </h2>
          </div>
          <button className="icon-button" onClick={onClose} aria-label={translate('Close')}>
            <SafeIcon name="FiX" />
          </button>
        </div>
        <p>
          {translate(
            'This view is planned but not built in the prototype yet. Nothing was changed or sent.'
          )}
        </p>
        <button className="button primary" onClick={onClose}>
          {translate('OK')}
        </button>
      </section>
    </div>
  );
}
